import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ChipInput from 'material-ui-chip-input';
import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BasicFileUploadComponent } from '../../utils/files';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > * + *': {
      marginTop: theme.spacing(1),
    },
  },
}));
const EditReview = ({ setOpenEditReviewModal }) => {
  const [adduserbadgeOpen, setAdduserbadgeOpen] = useState(false);
  const [addsubcategoryOpen, setAddsubcategoryOpen] = useState(false);
  const [addcategoryOpen, setAddcategoryOpen] = useState(false);
  const [addquestionOpen, setaddquestionOpen] = useState(false);
  const [reviewPostModel, setReviewPostModel] = useState({
    name: '',
    email: '',
    rating: '',
    badge: [],
    text: [],
    video: [],
  });
  const { community_id } = useParams();

  const [text, setText] = useState([
    {
      text: '',
      index: null,
    },
  ]);
  const [newquestion, setnewquestion] = useState({
    question: '',
    inputvideo: true,
    required: false,
  });
  console.log('newquestion', newquestion);
  const [selectedchampions, setselectedchampions] = useState('');

  const [directualCommunity, setDirectualCommunity] = useState({
    // id: 'temporary',
    name: 'Marshall Lousville',
    website: 'https://themarshalllouisville.com/', //(optional)
    communitybadges: [
      //   { name: 'Greate amendies', category: '' },
    ],

    champions: [
      // { profile: '', name: 'amulya', email: 'parmar@gmai.com' }
    ],

    //credits: 0,
    settings: {
      logo: 'https://i.imgur.com/NrZ3kph.png',
      address: '', //(optional)
      phone: '', // (optional),
      championssettings: {
        Bedroom: [{ subcategory: 'Workers' }, { subcategory: 'family' }],
        Dogs: [],
      },
      reviewSettings: {
        googleReviews:
          'https://search.google.com/local/writereview?placeid=ChIJsbivTn4F9YgR2YmRg350ljg&pli=1',
        form: {
          rating: false,
          video: true,
          text: true,
          name: true,
          email: true,
          questions: [], // if empt
        },
        goals: {
          CurrentReviewCount: 2,
          CurrentRating: 2,
          GoalRating: 2,
          ReviewScoreExpected: 5,
          GoalNumberofReviews: 2,
        },
      },
      referralSettings: {
        demographics: {},
      },
    },
  });
  const updatequestions = () => {
    if (directualCommunity.questions) {
      setDirectualCommunity({
        ...directualCommunity,
        questions: [...directualCommunity.questions, { ...newquestion }],
      });
    } else {
      setDirectualCommunity({
        ...directualCommunity,
        questions: [{ ...newquestion }],
      });
    }
    setnewquestion({
      question: '',
      inputvideo: true,
      inputtext: true,
      required: false,
    });
    setaddquestionOpen(false);
  };
  console.log('directualCommunity', directualCommunity);
  const [badgeName, setBadgeName] = useState('');
  const [newcategory, setnewcategory] = useState('');
  const addBadge = (e) => {
    setAdduserbadgeOpen(false);
    //e.preventDefault();
    setDirectualCommunity({
      ...directualCommunity,
      communitybadges: [
        ...directualCommunity.communitybadges,
        { name: badgeName, category: '' },
      ],
    });
    setBadgeName('');
  };
  const addcategory = (e) => {
    setAddcategoryOpen(false);
    e.preventDefault();
    setDirectualCommunity({
      ...directualCommunity,
      settings: {
        ...directualCommunity.settings,
        championssettings: {
          ...directualCommunity.settings.championssettings,
          [newcategory]: [],
        },
      },
    });
    setnewcategory('');
  };
  const addsubcategory = (e) => {
    setAdduserbadgeOpen(false);
    //e.preventDefault();
    setDirectualCommunity({
      ...directualCommunity,
      communitybadges: [
        ...directualCommunity.communitybadges,
        { name: badgeName, category: '' },
      ],
    });
    setBadgeName('');
  };
  const updatecommunity = async () => {
    try {
      let postData = {
        id: community_id,
        //...directualCommunity,
        name: directualCommunity.name,
        website: directualCommunity.website,
        communitybadges: {
          communitybadges: directualCommunity.communitybadges,
        },
        team: {
          team: directualCommunity.team,
        },
        reviews: {
          reviews: directualCommunity.reviews,
        },
        champions: {
          champions: directualCommunity.champions,
        },
        questions: {
          questions: directualCommunity.questions,
        },
        settings: {
          ...directualCommunity.settings,
        },
      };
      console.log('postData ', postData);
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(postData),
        redirect: 'follow',
      };

      fetch(
        `https://api.directual.com/good/api/v5/data/community/newCommunity?appID=f1a3bb81-3aba-43fb-8369-be1c35b3aa83&sessionID=`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          toast(`Setting updated`, {
            position: 'top-center',
            type: 'success',
            autoClose: 5000,
          });
          setOpenEditReviewModal(false);
        })
        .catch((error) => console.log('error', error));
      //console.log('userUpdated after review TYG: ', community);
    } catch (error) {
      console.log('error', error);
      console.log('error', error.response);
    }
  };
  const getcommunity = async () => {
    const res = await axios.get(
      `https://api.directual.com/good/api/v5/data/community/getCommunityById?appID=f1a3bb81-3aba-43fb-8369-be1c35b3aa83&communityId=${community_id}`
    );
    console.log('response', res);
    // console.log(
    //   'response',
    //   JSON.parse(res.data?.payload[0].settings)
    // );

    if (res.data) {
      try {
        let thejson = {
          ...directualCommunity,
          name: res.data?.payload[0].name,
          website: res.data?.payload[0].website,
        };
        if (res.data?.payload[0]?.communitybadges) {
          thejson.communitybadges = JSON.parse(
            res.data?.payload[0].communitybadges
          ).communitybadges;
        }
        if (res.data?.payload[0]?.champions) {
          thejson.champions = JSON.parse(
            res.data?.payload[0].champions
          ).champions;
        }
        if (res.data?.payload[0]?.reviews) {
          thejson.reviews = JSON.parse(res.data?.payload[0].reviews).reviews;
        }
        if (res.data?.payload[0]?.settings) {
          thejson.settings = JSON.parse(res.data?.payload[0]?.settings);
        }
        if (res.data?.payload[0]?.team) {
          thejson.team = JSON.parse(res.data?.payload[0].team).team;
        }
        if (res.data?.payload[0]?.questions) {
          thejson.questions = JSON.parse(
            res.data?.payload[0].questions
          ).questions;
        }
        // let thejson = {
        //   ...res.data?.payload[0],
        //   champions: JSON.parse(res.data?.payload[0].champions).champions,
        //   communitybadges: JSON.parse(res.data?.payload[0].communitybadges)
        //     .communitybadges,
        //   reviews: JSON.parse(res.data?.payload[0].reviews).reviews,
        //   settings: JSON.parse(res.data?.payload[0].settings),
        //   team: JSON.parse(res.data?.payload[0].team).team,
        //   questions: JSON.parse(res.data?.payload[0].questions).questions,
        // };
        //console.log('response',JSON.parse(res.data?.payload[0].champions))
        setDirectualCommunity({ ...thejson });
        console.log('after', directualCommunity);
        // setcreatecommunityenable(true);
        // setloading(false);
      } catch (error) {
        console.log('errr', error);
      }
    } else {
      console.log('response_empty');
    }
  };
  useEffect(() => {
    getcommunity();
  }, []);

  const [index, setIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const handleChangetext = (ind) => {
    if (text.find((e) => e.index !== ind)) {
      setSelectedIndex([...selectedIndex, ind]);
    }
  };

  const handleAddChip = (val) => {
    setDirectualCommunity({
      ...directualCommunity,
      communitybadges: [
        ...directualCommunity.communitybadges,
        { name: val, category: '' },
      ],
    });
  };

  const handleDeleteChip = (chip, selectedIndex) => {
    let communitybadges = directualCommunity?.communitybadges;
    communitybadges.splice(selectedIndex, 1);
    setDirectualCommunity({
      ...directualCommunity,
      communitybadges,
    });
  };

  const [rating, setRating] = useState(3.5);

  const Badge = ({ item }) => {
    console.log(item);
    const [selectBadge, setSelectBadge] = useState(false);
    return (
      <p
        onClick={() => setSelectBadge(!selectBadge)}
        className={
          selectBadge === false
            ? 'bg-gray-200 cursor-pointer px-3 text-xs py-2 rounded-3xl flex items-center gap-1'
            : 'bg-pr text-white cursor-pointer px-3 text-xs py-2 rounded-3xl flex items-center gap-1'
        }
      >
        {selectBadge === false ? (
          <AiOutlinePlus className=" w-2 h-2" />
        ) : (
          <IoCheckmarkOutline />
        )}{' '}
        {item}
      </p>
    );
  };

  return (
    <div className=" w-full flex items-start justify-start">
      <div className=" w-full lg:w-96  border-2 border-gray-500 rounded-md p-3 shadow-lg bg-white">
        <div className=" w-full border-b-2">
          <p className=" text-sm font-semibold">Community Name</p>
          <input
            type="text"
            className=" bg-transparent outline-none w-full py-1 text-sm"
            placeholder="Community Name"
            onChange={(e) => {
              setDirectualCommunity({
                ...directualCommunity,
                name: e.target.value,
              });
            }}
            value={directualCommunity?.name}
          />
        </div>
        <div className=" w-full border-b-2">
          <p className=" text-sm font-semibold">Website</p>
          <input
            type="text"
            className=" bg-transparent outline-none w-full py-1 text-sm"
            placeholder="Website"
            onChange={(e) => {
              setDirectualCommunity({
                ...directualCommunity,
                website: e.target.value,
              });
            }}
            value={directualCommunity?.website}
          />
        </div>
        <div className=" w-full border-b-2">
          <p className=" text-sm font-semibold">Google review link</p>
          <input
            type="text"
            className=" bg-transparent outline-none w-full py-1 text-sm"
            placeholder="Google review link"
            onChange={(e) => {
              setDirectualCommunity({
                ...directualCommunity,
                settings: {
                  ...directualCommunity.settings,
                  reviewSettings: {
                    googleReviews: e.target.value,
                  },
                },
              });
            }}
            value={directualCommunity?.settings?.reviewSettings?.googleReviews}
          />
        </div>
        <div className=" w-full">
          <p className=" text-sm font-semibold">Logo</p>

          <BasicFileUploadComponent
            defaultFile={directualCommunity?.settings?.logo}
            outerPath={community_id}
            onSuccess={(url) => {
              console.log('huzzah, the upload component works TYG', url);
              setDirectualCommunity({
                ...directualCommunity,
                settings: {
                  ...directualCommunity.settings,
                  logo: url,
                },
              });
            }}
          />
        </div>
        <div className=" w-full ">
          <p className=" text-sm font-semibold">Questions :</p>
          {directualCommunity?.questions?.map((item, index) => (
            <>
              <div className="flex ">
                <input
                  type="text"
                  className=" bg-transparent outline-none w-full py-1 text-sm"
                  placeholder="Write question..."
                  value={item.question}
                />
                <button
                  onClick={() => {
                    directualCommunity.questions?.splice(index, 1);
                    setDirectualCommunity({
                      ...directualCommunity,
                    });
                  }}
                  type="button"
                  class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                >
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div>
                Video :
                <Checkbox checked={item.inputvideo} />
                Text :
                <Checkbox checked={item.inputtext} />
                Required :
                <Checkbox checked={item.required} />
              </div>
            </>
          ))}
          <div>
            {addquestionOpen && (
              <>
                <input
                  type="text"
                  className=" bg-transparent outline-none w-full py-1 text-sm"
                  placeholder="Write question..."
                  value={newquestion.question}
                  onChange={(e) =>
                    setnewquestion({ ...newquestion, question: e.target.value })
                  }
                />
                <div>
                  Video :
                  <Checkbox
                    checked={newquestion.inputvideo}
                    onChange={(e) =>
                      setnewquestion({
                        ...newquestion,
                        inputvideo: e.target.checked,
                      })
                    }
                  />
                  Text :
                  <Checkbox
                    checked={newquestion.inputtext}
                    onChange={(e) =>
                      setnewquestion({
                        ...newquestion,
                        inputtext: e.target.checked,
                      })
                    }
                  />
                  Required :
                  <Checkbox
                    checked={newquestion.required}
                    onChange={(e) =>
                      setnewquestion({
                        ...newquestion,
                        required: e.target.checked,
                      })
                    }
                  />
                </div>
              </>
            )}
            {addquestionOpen ? (
              <button
                onClick={updatequestions}
                className="w-full flex flex-end items-end gap-2"
              >
                <p className=" text-sm font-bold">Save</p>
              </button>
            ) : (
              <button
                onClick={() => setaddquestionOpen(true)}
                className="w-full flex flex-end items-end gap-2"
              >
                <p className=" text-sm font-bold"> Add more+</p>
              </button>
            )}
          </div>
        </div>
        <div className=" w-full border-b-2">
          <p className=" text-sm font-semibold">Badges :</p>

          {adduserbadgeOpen === false ? (
            <button
              onClick={() => setAdduserbadgeOpen(true)}
              className=" bg-gray-100 border rounded-sm p-2 flex items-center gap-2"
            >
              <p className=" text-sm font-bold"> Add Badge</p> <AiOutlinePlus />
            </button>
          ) : (
            <form className=" flex" onSubmit={(e) => addBadge(e)}>
              <input
                type="text"
                autoFocus
                onChange={(e) => setBadgeName(e.target.value)}
                required
                className=" py-1 border rounded-sm px-2 w-32"
              />
            </form>
          )}
        </div>

        <ChipInput
          variant="outlined"
          placeholder="Add Badges"
          className="my-3"
          fullWidth
          blurBehavior="add"
          value={directualCommunity?.communitybadges.map((item) => item?.name)}
          onAdd={(chip) =>
            directualCommunity?.communitybadges.length < 10 &&
            handleAddChip(chip)
          }
          onDelete={(chip, index) => handleDeleteChip(chip, index)}
        />

        <div className="flex">
          <button
            onClick={updatecommunity}
            className="content-end	 bg-gray-100 border rounded-sm p-2 flex items-center gap-2"
          >
            <p className=" text-sm font-bold"> Save Settings</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditReview;
